import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import Cookies from 'js-cookie'

import publishers from '@/publisher/store/modules/publishers'
import toast from '@/publisher/store/modules/toast'
import forms from '@/publisher/store/modules/forms'
import sidebar from '@/publisher/store/modules/sidebar'
import conversion from '@/publisher/store/modules/conversion'

export default createStore({
  modules: {
    publishers,
    toast,
    forms,
    sidebar,
    conversion,
  },
  plugins: [
    createPersistedState({
      paths: ['publishers'],
      storage: {
        getItem: (key) => Cookies.get(key),
        setItem: (key, value) =>
          Cookies.set(key, value, { expires: 3, secure: true }),
        removeItem: (key) => Cookies.remove(key),
      },
    }),
  ],
})
